import Post from 'app/utils/Post';
import {getLinkPath} from 'app/utils/link_helper';

const REPORT_INTERVAL_MS = 5000;
const MAX_LENGTH = 2000;

let lastReportAt = 0;

interface ClientErrorPayload {
    message: string
    path: string
    stack: string
}

const describeError = (error: unknown): Pick<ClientErrorPayload, 'message' | 'stack'> => {
    if (error instanceof Error) {
        return {message: error.message, stack: error.stack || ''};
    }

    return {message: String(error), stack: ''};
};

export const reportClientError = (error: unknown, path: string, componentStack?: string | null): void => {
    const now = Date.now();

    if (now - lastReportAt < REPORT_INTERVAL_MS) {
        return;
    }

    lastReportAt = now;
    const {message, stack} = describeError(error);
    const clientError: ClientErrorPayload = {
        message: message.slice(0, MAX_LENGTH),
        path,
        stack: (componentStack ? `${stack}\n${componentStack}` : stack).slice(0, MAX_LENGTH)
    };

    new Post({params: {client_error: clientError}, url: getLinkPath('/client_errors')})
        .execute()
        .catch((): null => null);
};
